import { useEffect, useState } from 'react';
import { loadVGSScripts } from '../../../services/vgs/loadScripts/load';

export default function useVgsScripts(): boolean {
  const [scriptsLoaded, setScriptsLoaded] = useState(false);
  useEffect(() => {
    const loadScripts = async (): Promise<void> => {
      if (!window.VGSCollect || !window.VGSShow) {
        await loadVGSScripts();
        setScriptsLoaded(true);
      } else {
        setScriptsLoaded(true);
      }
    };
    loadScripts();
  });
  return scriptsLoaded;
}
